import React from 'react';
import Feature from '../../components/feature/Feature';
import './whatGPT3.css';

const WhatGPT3 = () => (
  <div className="gpt3__whatgpt3 section__margin" id="wgpt3">
    <div className="gpt3__whatgpt3-feature">
      <Feature title="What GLS is" text="This is a platform that provides myriad ideas with depth and breadth, that seek to edify the readers intellectually, morally, and mentally. It is a zoar of crystallized thoughts, dreams, and artistry." />
    </div>
    <div className="gpt3__whatgpt3-heading">
      <h1 className="gradient__text"> Masterpieces of literary pastimes</h1> 
      <p>"We laymen have always been curious to know; from what source that strange being, the creative writer, draws his material, and how he manages to make such an impression on us with it." – Freud (1908)</p>
     
    </div>
    <div className="gpt3__whatgpt3-heading">
    <p>Our drives:</p> 
    </div>
    
    <div className="gpt3__whatgpt3-container">
      <Feature title="Reality-Based" text="We provide contents that foster reconciliation with life's reality; fresh thoughts that can be implemented in our day-to-day operations. We lack sympathy towards the vulnerability of human feelings when beset by uncomfortable realities." />  
      <Feature title="Creativity" text="Our resources sparkle with profound creativity that zooms out an aerial view of the human soul, endeavouring to further the knowledge of our readers, enrich and improve the life of mankind." />
      <Feature title="Excellence" text="We give our readers the space to formulate their own imaginations according to their natural inclinations. Sometimes, we arrest their flight from reality." />
    </div>
  </div>
);

export default WhatGPT3;